module.exports = __webpack_public_path__ + "img/hallScreen.3e32cf0f.png";